
export const Config ={
    //local
    //baseUrl: "https://192.168.100.42:8000/api",
    //redirectUri: "https://192.168.100.42:3000/login",
    
    //prod
    baseUrl: "https://sigma-api.cetemin.net.pe/api",
    redirectUri: "https://sigma.cetemin.net.pe/login",
  

    apiSsoma: "https://ssoma-api.cetemin.net.pe/api"
}

